import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_CAMPAIGN = {
  'loading': false,
  'tasksArray': [],
  'loadingTask': false,
  'task': {},
};

export const campaignTasks = (state, action) => {
  return createReducer(INITIAL_STATE_CAMPAIGN, {
    [ActionTypes.FETCHING_CAMPAIGN_BY_ID]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_BY_ID]: (state, action) => {
      const {tasksArray} = action.response.data;
      return {
        ...state,
        'loading': false,
        'tasksArray': tasksArray || [],
      };
    },
    [ActionTypes.FETCHED_CAMPAIGN_BY_ID_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'tasksArray': [],
    }),
    [ActionTypes.ADDED_CAMPAIGN]: (state, action) => ({
      ...state,
      'tasksArray': [],
      'task': {},
      'model': {},
    }),
    [ActionTypes.ADDED_CAMPAIGN_FAILED]: (state, action) => ({
      ...state,
      'tasksArray': [],
      'task': {},
      'model': {},
    }),
    [ActionTypes.CLEAR_CAMPAIGN]: (state, action) => ({
      ...state,
      'loading': false,
      'tasksArray': [],
      'loadingTask': false,
      'task': {},
      'loadingModel': false,
      'model': {},
    }),
    [ActionTypes.PROCESSING_CAMPAIGN_CHASSIS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.PROCESSED_CAMPAIGN_CHASSIS]: (state, action) => {
      const {tasksArray} = action.response.data;
      return {
        ...state,
        'loading': false,
        'tasksArray': tasksArray || [],
      };
    },
    [ActionTypes.PROCESSED_CAMPAIGN_CHASSIS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'tasksArray': [],
    }),
    [ActionTypes.FETCHING_CAMPAIGN_TASK]: (state, action) => ({
      ...state,
      'loadingTask': true,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_TASK]: (state, action) => ({
      ...state,
      'loadingTask': false,
      'task': action.response.data,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_TASK_FAILED]: (state, action) => ({
      ...state,
      'loadingTask': false,
      'task': {},
    }),
    [ActionTypes.ADDING_ELEMENT_FOR_CAMPAIGN_TASKS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_ELEMENT_FOR_CAMPAIGN_TASKS]: (state, action) => ({
      ...state,
      'loading': false,
      'tasksArray': action.response.data.tasksArray,
      'task': {},
      'loadingTask': false,
      'model': {},
      'loadingModel': false,
    }),
    [ActionTypes.ADDED_ELEMENT_FOR_CAMPAIGN_TASKS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.REMOVING_ELEMENT_FOR_CAMPAIGN_TASKS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.REMOVED_ELEMENT_FOR_CAMPAIGN_TASKS]: (state, action) => ({
      ...state,
      'loading': false,
      'tasksArray': action.response.data.tasksArray,
    }),
    [ActionTypes.REMOVED_ELEMENT_FOR_CAMPAIGN_TASKS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
